
import { React, useState, useEffect, useRef, Component ,useImperativeHandle, forwardRef} from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ico1 from "../images/RoomIcon.png"
import ico2 from "../images/ExitIcon.png"
import styled from 'styled-components';
import Reservation from './Reservation';
import { useNavigate } from "react-router-dom";
import { Loading } from "../Loading";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tooltip,
  Stack,
  Chip,
  Paper,
} from "@mui/material";

import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import CheckIn from './CheckIn';
//import Resturant from './Resturant';
import ShowCheckIn_Data from './ShowCheckIn_Data';
import CheckOut from './CheckOut';
import "./Move.css";
import { SentimentVeryDissatisfied } from '@mui/icons-material';
import { Alert } from '@mui/material';
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
 import PrintIcon from "@mui/icons-material/Print";
 import SaveIcon from '@mui/icons-material/Save';
import EditNoteIcon from '@mui/icons-material/EditNote';
// import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
// import OutputIcon from "@mui/icons-material/Output";
//import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
// import DescriptionIcon from "@mui/icons-material/Description";
// import IosShareIcon from "@mui/icons-material/IosShare";


const Styles = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 50%;
  background-image: "../images/Back.png";    
  .flex-container {
      display: flex;
      Flex-direction: row;
      flex-flow: row wrap;
      margin-left: 50px;

      gap:50px;
  }
  .flex-items {
          //  background-color: #f4f4f4;
            width: 4100px;
           height: 50px;
           margin: 10px;
           display: none;
        //    text-align: center;
            font-size: 40px;
        }
        .flex-items-reservation {
          //  background-color: #f4f4f4; 
        
           /* top:0px; */
         //   width: 4100px;
           /* height: 50px;
           margin: 10px; */
     
           display:flex;
         margin: -89vh 113vh 0;  
         position:relative;
          justify-content:center; 
           font-size: 40px;
         
            //    margin-left:50px; 
        }
        .flex-items-resturant {
          //  background-color: #f4f4f4; 
        
           /* top:0px; */
         //   width: 4100px;
           /* height: 50px;
           margin: 10px; */
     
           display:flex;
         margin: -89vh 117vh 0;  
         position:relative;
          justify-content:center; 
           font-size: 40px;
         
            //    margin-left:50px; 
        }
 // justify-content: flex-start | flex-end | center | space-between | space-around;
 .motto {
     
     top:0px;
        margin-top:120px;
        height:480px;
        width:510px;
      }
      @media (max-width:850px) {
        .motto {
     
     top:0px;
    //    margin-top:740px;
    height:580px;
        width: 90vw;
        margin: 55vh 0vh 0;  
      }
      }
  .main-slide{
     position: relative;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;

     transition: all 0.3s ease-in-out;


      img {
       
          width: 100%;
           height: 290px; 
          object-fit: cover;
          display: block;
          overflow: hidden;
        //  background-color:black;
      //  background-image:"url('https://media.geeksforgeeks.org/wp-content/uploads/rk.png')";
 
       aspect-ratio: 1450 / 497;
      };
      .rect {

    width: 205px;
     height: 287px; 
    object-fit: none;
    display: block;
    overflow: hidden;
    background-color:white;
   
 aspect-ratio: 287 / 205;
};
      .zan {
     //   padding-top:200px;
             width: 100px;
           height: 100px; 
          object-fit:cover;
          display: flex;
          overflow: visible;
      //   aspect-ratio: 1450 / 497;
      }
      .zany {
     //   padding-top:200px;
             //   fill: yellow;
             width: 100px;
           height: 100px; 
          object-fit:cover;
          display: flex;
          overflow: visible;
      //    background-color:black;

      //   aspect-ratio: 1450 / 497;
      }
      .labely{
        color:yellow;
        display: flex;
      
      }
      .labelw{
       // align-items:left;
       // display:flex;
        
        text-align:left
      }
  
    }
`
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title" // فقط با گرفتن این ID میشه جابجا کرد
      cancel={'[class*="MuiDialogContent-root"]'} // از داخل محتوا نشه کشید
    >
      <Paper {...props} />
    </Draggable>
  );
}
export const RoomCard = ({ style, className, changeRestFlag, restflag, Flageckeck, Room_Number, changeUcount, Ucount, ChangeXpage ,getcolordata,permission}) => {
  const presentsRef = useRef(null);
  const [oreservation, setOreservation] = useState(false);
  const [Check_checkin, setCheck_checkin] = useState(false);
  const [Reserv_CheckOutflag, setReserv_CheckOutflag] = useState(false);
  const [ocheckout, setOcheckout] = useState(true);
  const [show_all, setShow_All] = useState(false);
  const [Pass_No, setPass_No] = useState('');
  const [CheckType, setCheckType] = useState(0);
  const [Reserv_Type,setReserv_Type]=useState(0);
  const [myrestflag, setmyrestflagt] = useState(false);
  const [Checkinflag, setCheckinflag] = useState(false);
  const [CheckOutflag, setCheckOutflag] = useState(false);
  const [CheckPerOutflag, setCheckPerOutflag] = useState(false);
  const [reservflag, setreservflag] = useState(false);
  const [reservdialogflag, setreservDialogflag] = useState(false);
  const [checkindialogflag, setcheckinDialogflag] = useState(false);
  const [Reserv_Id, setReserv_Id] = useState(0);
  const [data, setData] = useState({});
  const listItems = [];
  useEffect(() => {
if (permission.length !=0)
    setreservflag(permission[0].Per_View)
    setCheckinflag(permission[1].Per_View)
    setCheckPerOutflag(permission[2].Per_View)


  }, )
  useEffect(() => {
    if(Ucount !== 0){

                getData(1,2);
            
    }
 
  }, [Ucount])
  const [loading, setLoading] = useState(false);
  const getData = async (Reserv_Type1  , Reserv_Type2  ) => {
    console.log(Reserv_Type1,'=====',Reserv_Type2)
    // setData({})
    setLoading(true)
      let uparams = new URLSearchParams();
    
      let today =new Date();
   
  let day =0;
   day=today.getMonth();
   day=day+1;
      let date =today.getFullYear()+ '-'+ day + '-'+ today.getDate() ;
  
      uparams.append("Room_Number", Room_Number);
      uparams.append("Reserv_Type1", Reserv_Type1);
      uparams.append("Reserv_Type2", Reserv_Type2);
      let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectactive?${uparams}`, true);
       let parsed = JSON.parse(res);
   
      if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
          console.log(newData)
        setCheck_checkin(false)
              setData(newData)
              newData.map((dat) => 
              {  
                 if (dat.Reserv_Type ===2){
                    setCheck_checkin(true)
                }}

              
              )
            

        }
     else
     {
      setData([])
     }
      
    setLoading(false)

  }

  function handleReserv_Id(e) {
    setReserv_Id(e);
    localStorage.setItem('Reserv_Id', e)

    if (Reserv_Id > 0)
      changeRestFlag(true)
    setmyrestflagt(true)
  };
  const getPass_no = (e) => {
    setPass_No(e);
  };
  const checkout_flag = (e) => {
    setCheckOutflag(e);
  };
  const ChangeCheckOutflag = (e) => {
    setReserv_CheckOutflag(e);
  };
  const changeShowAll = async(e) => {

    setShow_All(e)
    if (e)
    {await getData(0,4)}
    else
    {
      await   getData(1,2)
    }
  };
  const handleClickOpen = () => {
    setOreservation(true);
  };
  const handleClosereservation = () => {
    setOreservation(false);
  };
  const handleCheck_CheckIn = () => {
    setCheck_checkin(false);
  };
  const handleCloseCheckOut = () => {
    setOcheckout(0);
    
   setCheckOutflag(true)
  };
  // const handleCloseresturant = () => {
  //   setOresturant(false);
  // };
  const myclick = (e) => {

    Flageckeck(false);
    ChangeXpage(0)
  }
  const bull = (
    <Box
      component="span"
      sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
      •
    </Box>
  );
  const navigate = useNavigate();
  function handelReservation() {
    // setOreservation(true)
    // changeRestFlag(false)
    ChangeXpage(1)

  }
  function ColorLabel({ color, label }) {
    return (
      <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
        <div
          style={{
            marginLeft:'10px',
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: color,
            display: "inline-block",
            border: "1px solid #888"
          }}
        ></div>
        <span style={{ fontSize: "12px" }}>{label}</span>
      </div>
    );
  }
  function handelCheckin(e) {
    // setOcheckin(true)
    // changeRestFlag(false)
    // ChangeXpage(e)
    switch (e) {
      case 1:
       setreservDialogflag(true)
        break;
    case 2:
      setcheckinDialogflag(true)
    break;
    case 3:
      setOcheckout(true)
    break;
      default:
        break;
    }
    setCheckType(e)
    setReserv_Type(e)
    // return (
    //   <Reservation Room_No={Room_Number} ChangeXpage={ChangeXpage} kk={2}  />
    // )
  }
  function handelCheckOut() {
    setOcheckout(true)
    changeRestFlag(false)
  }
  // function handelResturant() {
  //   setOresturant(true)
  //   //Room_wid
  //   // navigate("/reservation");
  // }
  function  ChangeXpage(e)
  {
    setCheckType(0)
  }
  let hei1 = window.innerHeight * 550 / 746;
  let wid1 = (window.innerWidth * 400 / 1528)+15;
  let wid = window.innerWidth;
  let hei = window.innerHeight;
  let Room_wid = '';
  let Room_hei = '';
  Room_wid = (wid / 2 - (wid * 659 / 1528) / 2) + 'px';
  Room_hei = (hei / 2 - (hei * 641 / 746) / 2 + 100) + 'px';

  const getReturn = () => {
    let htmlReturn = [
      //sx={{ width: wid1, height: hei1, marginTop: Room_hei }}
      <Styles>
      <Card className='motto'   key={0}>
        {/* <Card sx={{ minWidth: 50, maxWidth:Room_wid, width: Room_wid, height: Room_hei, marginLeft: -5 , transition: 'width 2s, height 4s , transform 2000s'}}> */}

        <div className="main-slide slidetype-2.3rem" style={{ float: 'left', display: 'inline', top: '0px', float: 'right', display: 'flex' }} >
          {/* <img   onClick={()=>myclick()} src={ico2}  style={{width:'30px',cursor:'pointer' , height:'30px',marginTop:'0px',marginLeft:'300px'}}  />  */}
          <img onClick={() => myclick()} src={ico2} alt={"/"} style={{ width: '50px', height: '50px', cursor: 'pointer',marginRight:'10px' }} />

        </div>


        <CardContent>

          <Typography gutterBottom sx={{ color: 'text.secondary', paddingTop: 0, fontSize: 18, width: 350, textAlign: 'left' }}>
            <div className="main-slide slidetype-2.3rem" style={{ float: 'left', display: 'inline', top: '-10px' }} >
              <img onClick={() => myclick()} src={ico1} alt={"/"} style={{ width: '50px', height: '50px' }} />
            </div>
            <div style={{ paddingLeft: '60px', paddingTop: '5px', fontWeight: 'bold', fontSize: '14px' }} >
              Room No : {Room_Number}
              <label style={{marginLeft:'40px'}}>Show All:
              <input style={{  width: '30px' }}
                type="checkbox"
                name="Reserv_Breakfast"
                id="Reserv_Breakfast"
                disabled={false}
                 value={show_all}
              checked={show_all}
             onChange={(e) => changeShowAll(e.target.checked)}
                defaultValue={0}
                //placeholder=""
                required
              />
              </label>
            </div>
          </Typography>
          <Typography variant="body2">
          </Typography>
        </CardContent>

        <Typography variant="h5" component="div" sx={{ color: 'text.secondary', fontSize: 10, fontWeight: 'normal', textAlign: 'left', marginLeft: 2, marginRight: 2, border: 'solid',height:'340px' }}>
          <ShowCheckIn_Data Room_Number={Room_Number} Ucount={Ucount} handleReservId={handleReserv_Id} data={data} getpassno={getPass_no} Checkoutflag={checkout_flag} CheckPerflag={CheckPerOutflag}/>
        </Typography>
        <CardActions sx={{ marginLeft: '60px' }}>

          <Stack spacing={1} >

            <Stack direction="row" spacing={1} >
            <Chip disabled ={!reservflag} label="Reservation" onClick={(() => handelCheckin(1))} sx={{left:'20px', fontSize: 10, height: 30, width: wid / 13 + 'px', backgroundColor: '#2C2C2C', color: "#ffffff", cursor: 'pointer', ":hover": { backgroundColor: "#EDD682", color: "#000000" } }} />
              <Chip label="Check IN" disabled={!Checkinflag} onClick={() => handelCheckin(2)} sx={{left:'20px', fontSize: 10, height: 30, width: wid / 14 + 'px', backgroundColor: '#2C2C2C', color: "#ffffff", cursor: 'pointer', ":hover": { backgroundColor: "#EDD682", color: "#000000" } }} />
              <Chip disabled={!CheckOutflag} label="Check Out" onClick={(() => handelCheckin(3))} sx={{ left:'20px',fontSize: 10, height: 30, width: wid / 14 + 'px', backgroundColor: '#2C2C2C', color: "#ffffff", cursor: 'pointer', ":hover": { backgroundColor: "#EDD682", color: "#000000" } }} />

            </Stack>
          </Stack>

        
        </CardActions>
        <div style={{marginTop:'-30px'}}>

{/* <label  for="Green" style={{marginLeft:'0px',backgroundColor:'#A6D9EF',color:'black',fontSize:'12px'}}> Blue = Free </label>
<label  for="yellow" style={{marginLeft:'20px',backgroundColor:'#5F8C5F',color:'black',fontSize:'12px'}}>Green = Reservation</label>
<label  for="red" style={{marginLeft:'20px',backgroundColor:'#F2595C',color:'white',fontSize:'12px'}}>Red = Check IN</label> */}
<ColorLabel color="green" label="Free  " />
<ColorLabel color="yellow" label="Reservation  " />
<ColorLabel color="#ff0000" label="Check IN" />
</div>
      </Card>
      </Styles>
    ];
    if(CheckType === 1){

      htmlReturn.push(
        
        <Styles key={1}>
  
            <Dialog
                    open={reservdialogflag}
                    onClose={(event, reason) => {
                      if (reason === "backdropClick") return;
                      setreservDialogflag(false);
                    }}
                    PaperComponent={PaperComponent}
                    PaperProps={{
                      sx: {
                        maxWidth: 1050,
                        maxHeight: 570,
                        width: 1050,
                        height: 570,
                        backgroundColor: '#F2F2F2'
                      },
                    }}
                  >
                    {/* 🔹 Header قابل جابه‌جایی */}
                    <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Tooltip title="New" arrow>
                          <IconButton color="primary" onClick={() => presentsRef.current?.new()}>
                            <FiberNewIcon />
                          </IconButton>
                        </Tooltip>
              
                        <Tooltip title="Save" arrow>
                          <IconButton color="primary" onClick={() => presentsRef.current?.add()}>
                            <SaveIcon />
                          </IconButton>
                        </Tooltip>
              
                        <Tooltip title="Edit" arrow>
                          <IconButton color="primary" onClick={() => presentsRef.current?.edit()}>
                            <EditNoteIcon />
                          </IconButton>
                        </Tooltip>
              
                        <Tooltip title="Voucher" arrow>
                          <IconButton color="error" onClick={() => presentsRef.current?.voucher()}>
                            <PrintIcon sx={{ color: "#1976d2" }} />
                          </IconButton>
                        </Tooltip>
        
                      </Stack>
              
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>Reservation</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => setreservDialogflag(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>
              
                    {/* 📦 محتوا */}
                    <DialogContent sx={{ p: 2 }}>
                    <Reservation   ref={presentsRef} permission={permission} Room_No={Room_Number} ChangeXpage={ChangeXpage} Reserv_Id={Reserv_Id} getDataCard={getData}  Reserv_Type={Reserv_Type} kk={2} />

                                       
                    </DialogContent>
                  </Dialog>
          </Styles>
      )
    }
    if(CheckType === 2){
      htmlReturn.push(
        <Styles key={1}>
        
            <Dialog
                    open={checkindialogflag}
                    onClose={(event, reason) => {
                      if (reason === "backdropClick") return;
                      setcheckinDialogflag(false);
                    }}
                    PaperComponent={PaperComponent}
                    PaperProps={{
                      sx: {
                        maxWidth: 1050,
                        maxHeight: 570,
                        width: 1050,
                        height: 570,
                        backgroundColor: '#F2F2F2'
                      },
                    }}
                  >
                    {/* 🔹 Header قابل جابه‌جایی */}
                    <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Tooltip title="New" arrow>
                          <IconButton color="primary" onClick={() => presentsRef.current?.new()}>
                            <FiberNewIcon />
                          </IconButton>
                        </Tooltip>
              
                        <Tooltip title="Save" arrow>
                          <IconButton color="primary" onClick={() => presentsRef.current?.add()}>
                            <SaveIcon />
                          </IconButton>
                        </Tooltip>
              
                        <Tooltip title="Edit" arrow>
                          <IconButton color="primary" onClick={() => presentsRef.current?.edit()}>
                            <EditNoteIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Change Room" arrow >
                        <Button  style={{fontSize:'8px',fontWeight:'bold'}} onClick={() => presentsRef.current?.changerom()}>Change Room</Button>
                        </Tooltip>
                      </Stack>
              
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>Check In</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => setcheckinDialogflag(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>
              
                    {/* 📦 محتوا */}
                    <DialogContent sx={{ p: 2 }}>
                      <Reservation  ref={presentsRef}  permission={permission}  Room_No={Room_Number} ChangeXpage={ChangeXpage} Reserv_Id={Reserv_Id} getDataCard={getData}  Reserv_Type={Reserv_Type} kk={2} />
                             
                    </DialogContent>
                  </Dialog>

          </Styles>
      )

    }
    if(CheckType === 3){
      htmlReturn.push(
        <Styles key={1}>
            {/* <Dialog
                open={ocheckout}
                onClose={()=>handleCloseCheckOut()}
                PaperProps={{
                    sx: {
                        maxWidth: 950,
                        maxHeight: 660,
                        width: 950,
                        height: 660,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
                <DialogTitle>Check Out</DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <div className="flex-items-resturant" >
                <div className="main-slide" style={{ marginTop: '0px' }} >
                  
                   <CheckOut permission={permission} Room_No={Room_Number} Pass_No={Pass_No}  ChangeXpage={ChangeXpage} Reserv_Id={Reserv_Id} getDataCard={getData}  Reserv_Type={Reserv_Type} kk={2} />
                </div>
              </div>
                  </DialogContent>
                <DialogActions    >
                    <Stack direction="row" spacing={1} style={{ paddingRight: '40px' }}>
                        <Chip label="Exit" color="primary" onClick={()=>handleCloseCheckOut()} sx={{ width: 150, cursor: 'pointer' }} />
                    </Stack>


                </DialogActions>
            </Dialog> */}
            <Dialog
                    open={ocheckout}
                    onClose={(event, reason) => {
                      if (reason === "backdropClick") return;
                      setOcheckout(false);
                    }}
                    PaperComponent={PaperComponent}
                    PaperProps={{
                      sx: {
                        maxWidth: 980,
                        maxHeight: 600,
                        width: 980,
                        height: 600,
                        backgroundColor: '#F2F2F2'
                      },
                    }}
                  >
                    {/* 🔹 Header قابل جابه‌جایی */}
                    <DialogTitle
                      id="draggable-dialog-title"
                      sx={{
                        cursor: "move",
                        userSelect: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        p: 1,
                        borderBottom: "1px solid #ddd",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* 👈 سمت چپ: دکمه‌های اکشن */}
                      <Stack direction="row" spacing={1} alignItems="center">
                        {/* <Tooltip title="New" arrow>
                          <IconButton color="primary" onClick={() => presentsRef.current?.new()}>
                            <FiberNewIcon />
                          </IconButton>
                        </Tooltip> */}
              
                        <Tooltip title="Save" arrow>
                          <IconButton color="primary" disabled={!Reserv_CheckOutflag} onClick={() => presentsRef.current?.add()}>
                            <SaveIcon />
                          </IconButton>
                        </Tooltip>
              
                        {/* <Tooltip title="Edit" arrow>
                          <IconButton color="primary" onClick={() => presentsRef.current?.edit()}>
                            <EditNoteIcon />
                          </IconButton>
                        </Tooltip>
               */}
                        <Tooltip title="Voucher" arrow>
                          <IconButton color="error" onClick={() => presentsRef.current?.invoice()}>
                            <PrintIcon sx={{ color: "#1976d2" }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
              
                      {/* 🟢 وسط: عنوان دیالوگ */}
                      <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                        <span style={{ fontWeight: 600, fontSize: "1rem" }}>Check Out</span>
                      </Box>
              
                      {/* 👉 سمت راست: دکمه خروج */}
                      <Tooltip title="Exit" arrow>
                        <IconButton color="error" onClick={() => setOcheckout(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </DialogTitle>
              
                    {/* 📦 محتوا */}
                    <DialogContent sx={{ p: 2 }}>
                                     <CheckOut ref={presentsRef} permission={permission} Room_No={Room_Number} Pass_No={Pass_No}  ChangeXpage={ChangeXpage} Reserv_Id={Reserv_Id} ChangeCheckOutflag={ChangeCheckOutflag} getDataCard={getData}  Reserv_Type={Reserv_Type} kk={2} />

                    </DialogContent>
                  </Dialog>

            {/* <div className="flex-container" style={{width:'600px',height:'600px',backgroundColor:'black'}} > */}
            {/* style={{  marginTop: Room_hei , marginLeft: wid / 5 + 10 + 'px', display: 'flex' }} */}
          
            {/* </div> */}
          </Styles>
      )
    }
 
    return htmlReturn;
  }
  return getReturn()
 

}



